import CONST from './Constant';
import axiosPrivate from '../../../../Setup/Axios/SetupAxios';
import {handleAsyncAction} from "../../../../Setup";
import {fetchAppConfig} from "../../../Common/App";

/****************************************
 HOLIDAY ACTIONS
 ****************************************/
export const fetchHolidaysSuccess = (payload) => ({
    type: 'FETCH_HOLIDAYS_SUCCESS',
    payload: payload
});

export const fetchHolidaysFailed = (payload) => ({
    type: 'FETCH_HOLIDAYS_FAILED',
    payload: payload
});

export const fetchHolidays = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/holidays', { params: filters }),
        [fetchHolidaysSuccess],
        [fetchHolidaysFailed]
    );
};

export const addHolidaySuccess = (payload) => ({
    type: 'ADD_HOLIDAY_SUCCESS',
    payload: payload
});

export const addHolidayFailed = (payload) => ({
    type: 'ADD_HOLIDAY_FAILED',
    payload: payload
});

export const addHoliday = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/holidays', data),
        [addHolidaySuccess],
        [addHolidayFailed]
    );
};

export const updateHolidaySuccess = (payload) => ({
    type: 'UPDATE_HOLIDAY_SUCCESS',
    payload: payload
});

export const updateHolidayFailed = (payload) => ({
    type: 'UPDATE_HOLIDAY_FAILED',
    payload: payload
});

export const updateHoliday = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/holidays/${data['id']}`, data),
        [updateHolidaySuccess],
        [updateHolidayFailed]
    );
};

export const deleteHolidaySuccess = (payload) => ({
    type: 'DELETE_HOLIDAY_SUCCESS',
    payload: payload
});

export const deleteHolidayFailed = (payload) => ({
    type: 'DELETE_HOLIDAY_FAILED',
    payload: payload
});

export const deleteHoliday = ({dispatch, id}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`core/holidays/${id}`),
        [deleteHolidaySuccess],
        [deleteHolidayFailed]
    );
};

/****************************************
 VENUE ACTIONS
 ****************************************/
export const fetchVenuesSuccess = (payload) => ({
    type: 'FETCH_VENUES_SUCCESS',
    payload: payload,
});

export const fetchVenuesFailed = (payload) => ({
    type: 'FETCH_VENUES_FAILED',
    payload: payload,
});

export const fetchVenues = ({ dispatch, filters }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/venues', { params: filters }),
        [fetchVenuesSuccess],
        [fetchVenuesFailed]
    );
};

export const addVenueSuccess = (payload) => ({
    type: 'ADD_VENUE_SUCCESS',
    payload: payload,
});

export const addVenueFailed = (payload) => ({
    type: 'ADD_VENUE_FAILED',
    payload: payload,
});

export const addVenue = ({ dispatch, data }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/venues', data),
        [addVenueSuccess],
        [addVenueFailed]
    );
};

export const updateVenueSuccess = (payload) => ({
    type: 'UPDATE_VENUE_SUCCESS',
    payload: payload,
});

export const updateVenueFailed = (payload) => ({
    type: 'UPDATE_VENUE_FAILED',
    payload: payload,
});

export const updateVenue = ({ dispatch, data }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/venues/${data['id']}`, data),
        [updateVenueSuccess],
        [updateVenueFailed]
    );
};

export const deleteVenueSuccess = (payload) => ({
    type: 'DELETE_VENUE_SUCCESS',
    payload: payload,
});

export const deleteVenueFailed = (payload) => ({
    type: 'DELETE_VENUE_FAILED',
    payload: payload,
});

export const deleteVenue = ({ dispatch, id }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`core/venues/${id}`),
        [deleteVenueSuccess],
        [deleteVenueFailed]
    );
};

/****************************************
 LOCATION ACTIONS
 ****************************************/
export const fetchLocationsSuccess = (payload) => ({
    type: 'FETCH_LOCATIONS_SUCCESS',
    payload: payload,
});

export const fetchLocationsFailed = (payload) => ({
    type: 'FETCH_LOCATIONS_FAILED',
    payload: payload,
});

export const fetchLocations = ({ dispatch, filters }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/locations', { params: filters }),
        [fetchLocationsSuccess],
        [fetchLocationsFailed]
    );
};

export const addLocationSuccess = (payload) => ({
    type: 'ADD_LOCATION_SUCCESS',
    payload: payload,
});

export const addLocationFailed = (payload) => ({
    type: 'ADD_LOCATION_FAILED',
    payload: payload,
});

export const addLocation = ({ dispatch, data }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/locations', data),
        [addLocationSuccess],
        [addLocationFailed]
    );
};

export const updateLocationSuccess = (payload) => ({
    type: 'UPDATE_LOCATION_SUCCESS',
    payload: payload,
});

export const updateLocationFailed = (payload) => ({
    type: 'UPDATE_LOCATION_FAILED',
    payload: payload,
});

export const updateLocation = ({ dispatch, data }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/locations/${data['id']}`, data),
        [updateLocationSuccess],
        [updateLocationFailed]
    );
};

export const deleteLocationSuccess = (payload) => ({
    type: 'DELETE_LOCATION_SUCCESS',
    payload: payload,
});

export const deleteLocationFailed = (payload) => ({
    type: 'DELETE_LOCATION_FAILED',
    payload: payload,
});

export const deleteLocation = ({ dispatch, id }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`core/locations/${id}`),
        [deleteLocationSuccess],
        [deleteLocationFailed]
    );
};

/****************************************
 EVENT ACTIONS
 ****************************************/
export const fetchEventsSuccess = (payload) => ({
    type: 'FETCH_EVENTS_SUCCESS',
    payload: payload,
});

export const fetchEventsFailed = (payload) => ({
    type: 'FETCH_EVENTS_FAILED',
    payload: payload,
});

export const fetchEvents = ({ dispatch, filters }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/events', { params: filters }),
        [fetchEventsSuccess],
        [fetchEventsFailed]
    );
};

export const addEventSuccess = (payload) => ({
    type: 'ADD_EVENT_SUCCESS',
    payload: payload,
});

export const addEventFailed = (payload) => ({
    type: 'ADD_EVENT_FAILED',
    payload: payload,
});

export const addEvent = ({ dispatch, data }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/events', data),
        [addEventSuccess],
        [addEventFailed]
    );
};

export const updateEventSuccess = (payload) => ({
    type: 'UPDATE_EVENT_SUCCESS',
    payload: payload,
});

export const updateEventFailed = (payload) => ({
    type: 'UPDATE_EVENT_FAILED',
    payload: payload,
});

export const updateEvent = ({ dispatch, data }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/events/${data['id']}`, data),
        [updateEventSuccess],
        [updateEventFailed]
    );
};

export const deleteEventSuccess = (payload) => ({
    type: 'DELETE_EVENT_SUCCESS',
    payload: payload,
});

export const deleteEventFailed = (payload) => ({
    type: 'DELETE_EVENT_FAILED',
    payload: payload,
});

export const deleteEvent = ({ dispatch, id }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`core/events/${id}`),
        [deleteEventSuccess],
        [deleteEventFailed]
    );
};

/****************************************
 FETCH DYNAMIC OPTIONS
 ****************************************/
export const fetchOptions = async ({dispatch, url, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(url, { params: filters }),
        [],
        []
    );
}

/****************************************
 FETCH SETTING
 ****************************************/
export const fetchSettingSuccess = (payload) => ({
    type: CONST.FETCH_SETTING_SUCCESS,
    payload: payload
})

export const fetchSettingFailed = (payload) => ({
    type: CONST.FETCH_SETTING_FAILED,
    payload: payload
})

export const fetchSetting = async ({dispatch, filters}) => {

    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/settings', { params: filters }),
        [fetchSettingSuccess],
        [fetchSettingFailed]
    );
}

/****************************************
 FETCH SETTINGS
 ****************************************/
export const fetchSettingsSuccess = (payload) => ({
    type: CONST.FETCH_SETTINGS_SUCCESS,
    payload: payload
})

export const fetchSettingsFailed = (payload) => ({
    type: CONST.FETCH_SETTINGS_FAILED,
    payload: payload
})

export const fetchSettings = async ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/settings', { params: filters }),
        [fetchSettingsSuccess],
        [fetchSettingsFailed]
    );
}

/****************************************
 SET ACTIVE MENU
 ****************************************/
export const setActiveMenu = (menuId) => ({
    type: CONST.SET_ACTIVE_MENU,
    payload: menuId
})

/****************************************
 UPDATE SETTING
 ****************************************/
export const updateSettingSuccess = (payload) => ({
    type: CONST.UPDATE_SETTING_SUCCESS,
    payload: payload
})

export const updateSettingFailed = (payload) => ({
    type: CONST.UPDATE_SETTING_FAILED,
    payload: payload
})

export const updateSetting = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch('core/settings', data),
        [updateSettingSuccess, () => fetchAppConfig({ dispatch })],
        [updateSettingFailed],
    );
}


/****************************************
 ADD SETTING
 ****************************************/
export const addSettingSuccess = (payload) => ({
    type: CONST.ADD_SETTING_SUCCESS,
    payload: payload
})

export const addSettingFailed = (payload) => ({
    type: CONST.ADD_SETTING_FAILED,
    payload: payload
})

export const addSetting = async ({dispatch, data}) => {

    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/settings', data),
        [addSettingSuccess],
        [addSettingFailed]
    );
}

/****************************************
 Add Themes
 ****************************************/
export const addTheme = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/themes', data),
        [],
        []
    );
}

/****************************************
 Fetch Themes
 ****************************************/
export const fetchThemes = async ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/themes', { params: filters }),
        [],
        []
    );
}

/****************************************
 Fetch Themes
 ****************************************/
export const fetchTheme = async ({dispatch, id}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(`core/themes/${id}`),
        [],
        []
    );
}

/****************************************
 Update Theme
 ****************************************/
export const updateTheme = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/themes/${data.id}`, data),
        [],
        []
    );
}

/****************************************
 Delete Theme
 ****************************************/
export const deleteTheme = async ({dispatch, id}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`core/themes/${id}`),
        [],
        []
    );
}

/****************************************
 FETCH LEAVE TYPES
 ****************************************/
export const fetchLeaveTypes = async ({dispatch, filters}) => {

    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('hrms/leave-types', { params: filters }),
        [],
        []
    );
}


/****************************************
 DOCUMENT TYPES
 ****************************************/
export const fetchDocumentType = async ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(`core/document-types/${filters['id']}`, { params: filters }),
        [],
        []
    );
}

export const fetchDocumentTypes = async ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/document-types', { params: filters }),
        [],
        []
    );
}

export const addDocumentType = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/document-types', data),
        [],
        []
    );
}

export const updateDocumentType = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/document-types/${data.id}`, data),
        [],
        []
    );
}

export const deleteDocumentType = async ({dispatch, id}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`core/document-types/${id}`),
        [],
        []
    );
}

/****************************************
 Entities
****************************************/
export const fetchEntity = async ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(`core/entity/${filters['id']}`, { params: filters }),
        [],
        []
    );
}
export const fetchEntities = async ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/entities', { params: filters }),
        [],
        []
    );
}

export const addEntity = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/entities', data),
        [],
        []
    );
}

export const updateEntity = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/entities/${data.id}`, data),
        [],
        []
    );
}

export const deleteEntity = async ({dispatch, id}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`core/entities/${id}`),
        [],
        []
    );
}


/****************************************
 STATUSES
 ****************************************/
export const fetchStatus = async ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(`core/statuses/${filters['id']}`, { params: filters }),
        [],
        []
    );
}

export const fetchStatuses = async ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/statuses', { params: filters }),
        [],
        []
    );
}

export const addStatus = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/statuses', data),
        [],
        []
    );
}

export const updateStatus = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/statuses/${data.id}`, data),
        [],
        []
    );
}

export const deleteStatus = async ({dispatch, id}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`core/statuses/${id}`),
        [],
        []
    );
}

/****************************************
 STATUS TYPES
****************************************/
export const fetchStatusType = async ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(`core/status-types/${filters['id']}`, { params: filters }),
        [],
        []
    );
}

export const fetchStatusTypes = async ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/status-types', { params: filters }),
        [],
        []
    );
}

export const addStatusType = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/status-types', data),
        [],
        []
    );
}

export const updateStatusType = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`core/status-types/${data.id}`, data),
        [],
        []
    );
}

export const deleteStatusType = async ({dispatch, id}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`core/status-types/${id}`),
        [],
        []
    );
}